import { DragOverlay } from "@dnd-kit/core";
import React from "react";
import { createPortal } from "react-dom";

export function DommusCustomDragOverlay({children}){
  const elemento = document.getElementById('scrollContainer');
  return createPortal(
      <DragOverlay
        style={{
          pointerEvents: 'none',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        adjustScale={false}
      >
        {children}
      </DragOverlay>,
      elemento 
    );
}
